import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome, faArchive, faUser } from "@fortawesome/free-solid-svg-icons";
import "../commons/NavbarTechnician.css";
import { NavLink } from "react-router-dom";

class NavbarAdmin extends React.Component {
  render() {
    return (
      <React.Fragment>
        <nav
          id="navbarTec"
          className="navbar navbar-expand-lg navbar-dark bg-dark fixed-bottom"
        >
          <div className="container text-center navbInferior">
            <div className="home">
              <NavLink to="/home_admin">
                <span className="iconSizeNav">
                  <FontAwesomeIcon icon={faHome} />
                </span>
                <span style={{ display: "block" }}> Dents</span>
              </NavLink>
            </div>
            <div className="job">
              <NavLink to="/Dashboard">
                <span className="iconSizeNav">
                  <FontAwesomeIcon icon={faArchive} />
                </span>
                <span style={{ display: "block" }}>Dents to estimate</span>
              </NavLink>
            </div>
          </div>
        </nav>
      </React.Fragment>
    );
  }
}
export default NavbarAdmin;
